import { FULL_GLOBAL_SEARCH, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  keyword: '',
  value: '',
  list: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  pages: 10,
  details: {}
};

const searchReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_GLOBAL_SEARCH.Keyword: {
      return {
        ...state,
        keyword: action.payload
      };
    }
    case FULL_GLOBAL_SEARCH.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_GLOBAL_SEARCH.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case GLOBAL_CATALOGS.FullTextSearch: {
      return {
        ...state,
        ...action.payload
        // list
        // total
      };
    }
    default: {
      return state;
    }
  }
};

export default searchReducer;
